import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJobApplications, editJobApplications } from "../../slice/workerJobSlice";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";

const WorkerJobApplications = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { jobApplications, loading, error } = useSelector(
        (state) => state.workerJob
    );
    const token = localStorage.getItem("token");
    const [showModal, setShowModal] = useState(false);
    const [selectedApplication, setSelectedApplication] = useState(null);

    const [status, setStatus] = useState("");
    const [salaryType, setSalaryType] = useState("");
    const [salary, setSalary] = useState("");
    const [duration, setDuration] = useState("");
    const [updating, setUpdating] = useState(false);
    const [filters, setFilters] = useState({
        keyword: "",
        status: "",
        job: "",
    });

    useEffect(() => {
        if (!token) return;

        dispatch(getJobApplications({ token, filters }));
    }, [token, dispatch]);

    const handleUpdate = () => {
        if (!selectedApplication) return;

        if (salaryType == "") {
            toast.error("Please select salary type");
            return;
        }

        if (salary <= 0) {
            toast.error("Please Enter Salary amount");
            return;
        }

        if (duration <= 0) {
            toast.error("Please Enter duration");
            return;
        }

        const formData = {
            application_id: selectedApplication.id,
            status,
            salary_type: salaryType,
            salary: Number(salary),
            duration: Number(duration),
        };

        setUpdating(true);

        dispatch(editJobApplications({ token, formData }))
            .unwrap()
            .then(() => {
                toast.success("Application updated");
                setShowModal(false);
                dispatch(getJobApplications({ token, filters }));
            })
            .catch((err) => toast.error(err))
            .finally(() => {
                setUpdating(false);
            });
    };

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case "applied":
                return "bg-primary";       // blue
            case "shortlisted":
                return "bg-info text-dark"; // light blue / info
            case "rejected":
                return "bg-danger";        // red
            case "interview":
                return "bg-warning text-dark"; // yellow
            case "accepted":
                return "bg-success";       // green
            default:
                return "bg-secondary";     // grey
        }
    };

    const handleStatusUpdate = (app, newStatus, needsOffer = false) => {
        let payload = {
            application_id: app.id,
            status: newStatus,
        };

        if (needsOffer && (!salaryType || !salary || !duration)) {
            toast.error("Please fill salary details");
            return;
        }

        // only for applied / hired
        if (needsOffer) {
            payload = {
                ...payload,
                salary_type: salaryType,
                salary: Number(salary),
                duration: Number(duration),
            };
        }

        dispatch(editJobApplications({ token, formData: payload }))
            .unwrap()
            .then(() => {
                toast.success("Application updated");
                setShowModal(false);
                dispatch(getJobApplications({ token, filters }));
            })
            .catch((err) => toast.error(err));
    };


    console.log("jobApplications", jobApplications);
    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">

            <div className="ps-2 ps-lg-4">
                <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-3 border-bottom">
                    My Job Applications
                </h4>

                {/* FILTER BAR */}
                <div className="card shadow-sm mb-4">
                    <div className="card-body">
                        <div className="row g-3 align-items-end">

                            {/* Keyword */}
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Keyword</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search keyword..."
                                    value={filters.keyword}
                                    onChange={(e) =>
                                        setFilters({ ...filters, keyword: e.target.value })
                                    }
                                />
                            </div>

                            {/* Status */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Status</label>
                                <select
                                    className="form-select"
                                    value={filters.status}
                                    onChange={(e) =>
                                        setFilters({ ...filters, status: e.target.value })
                                    }
                                >
                                    <option value="">All Status</option>
                                    <option value="applied">Applied</option>
                                    <option value="shortlisted">Shortlisted</option>
                                    <option value="interview">Interviewed</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            {/* Job */}
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Job</label>
                                <select
                                    className="form-select"
                                    value={filters.job}
                                    onChange={(e) =>
                                        setFilters({ ...filters, job: e.target.value })
                                    }
                                >
                                    <option value="">All Jobs</option>
                                    {[...new Map(
                                        jobApplications?.map(app => [app.job.id, app.job])
                                    ).values()].map(job => (
                                        <option key={job.id} value={job.id}>
                                            {job.title}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Buttons */}
                            <div className="col-md-2 d-flex gap-2">
                                <button
                                    className="btn btn-success w-100"
                                    onClick={() => dispatch(getJobApplications({ token, filters }))}
                                    disabled={loading}
                                >
                                    Apply
                                </button>

                                <button
                                    className="btn btn-outline-secondary w-100"
                                    onClick={() => {
                                        const cleared = { keyword: "", status: "", job: "" };
                                        setFilters(cleared);
                                        dispatch(getJobApplications({ token, filters: cleared }));
                                    }}
                                >
                                    Clear
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {/* LOADING */}
                {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}

                {/* ERROR */}
                {error && <p className="text-danger">{error}</p>}

                {/* EMPTY STATE */}
                {!loading && jobApplications?.length === 0 && (
                    <p className="text-muted">You have not applied to any jobs yet.</p>
                )}

                {/* APPLICATION LIST */}
                {!loading && jobApplications?.length > 0 && (
                    <div className="card shadow-sm">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th className="font-weight-semibold">User</th>
                                        <th className="font-weight-semibold">Job Title</th>
                                        <th className="font-weight-semibold">Status</th>
                                        <th className="font-weight-semibold">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {jobApplications.map((app, index) => (
                                        <tr key={app.id}>
                                            <td>
                                                <Link
                                                    to={`/resume-user-detail/${app.id}`}
                                                    target="_blank"
                                                    style={{
                                                        textTransform: "uppercase",
                                                        color: "#0d6efd",
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {app.user.first_name}
                                                </Link>
                                            </td>
                                            <td>{app.job.title}</td>

                                            <td>
                                                <span className={`badge ${getStatusClass(app.status)} text-uppercase`}>
                                                    {app.status}
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    className="btn btn-sm btn-success me-2"
                                                    onClick={() => {
                                                        setSelectedApplication(app);
                                                        setStatus("accepted");
                                                        setSalaryType("");
                                                        setSalary("");
                                                        setDuration("");
                                                        setShowModal(true);
                                                    }}
                                                >
                                                    Accept
                                                </button>

                                                <button
                                                    className="btn btn-sm btn-dark me-2"
                                                    onClick={() => handleStatusUpdate(app, "interview")}
                                                >
                                                    Interviewed
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-secondary me-2"
                                                    onClick={() => handleStatusUpdate(app, "shortlisted")}
                                                >
                                                    Shortlisted
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => handleStatusUpdate(app, "rejected")}
                                                >
                                                    Rejected
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        zIndex: 1050,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div
                        className="modal-dialog"
                        style={{
                            pointerEvents: "auto",
                            maxWidth: "600px",
                            width: "90%",
                        }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Update Job Application</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                />
                            </div>

                            <div className="modal-body">
                                {/* <div className="mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                    >
                                        <option value="applied">Applied</option>
                                        <option value="shortlisted">Shortlisted</option>
                                        <option value="rejected">Rejected</option>
                                        <option value="interview">Interview</option>
                                        <option value="hired">Hired</option>
                                    </select>
                                </div> */}

                                <div className="mb-3">
                                    <label className="form-label required">Salary Type</label>
                                    <select
                                        className="form-select"
                                        value={salaryType}
                                        onChange={(e) => setSalaryType(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="hourly">Hourly</option>
                                        <option value="yearly">Yearly</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label required">Salary</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={salary}
                                        onChange={(e) => setSalary(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label required">Duration</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                    />
                                </div>
                            </div>


                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-success"
                                    onClick={handleUpdate}
                                    disabled={updating}
                                >
                                    {updating ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Updating...
                                        </>
                                    ) : (
                                        "Update"
                                    )}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};

export default WorkerJobApplications;